import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X, ShoppingBag, ShieldCheck } from "@phosphor-icons/react";
import { useShop } from "@/context/ShopContext";

export default function CartDrawer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { cart, cartOpen, setCartOpen, updateQty, removeFromCart, cartSubtotal, format } = useShop();

  return (
    <>
      {cartOpen && (
        <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm" onClick={()=>setCartOpen(false)} data-testid="cart-drawer-overlay">
          <aside className="absolute right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl flex flex-col" onClick={e=>e.stopPropagation()} data-testid="cart-drawer">
            <div className="flex items-center justify-between p-6 border-b border-[var(--bm-border)]">
              <h2 className="font-serif-bm text-2xl">{t("cart.title")}</h2>
              <button onClick={()=>setCartOpen(false)} aria-label="close" data-testid="cart-close-btn"><X size={20} weight="thin"/></button>
            </div>
            <div className="flex-1 overflow-y-auto scrollbar-thin p-6 space-y-5">
              {cart.length === 0 ? (
                <div className="text-center py-20 text-[var(--bm-muted)]">
                  <ShoppingBag size={36} weight="thin" className="mx-auto mb-3"/>
                  <p>{t("cart.empty")}</p>
                </div>
              ) : cart.map(item => (
                <div key={item.product_id} className="flex gap-4" data-testid={`cart-item-${item.product_id}`}>
                  <Link to={`/product/${item.slug}`} onClick={()=>setCartOpen(false)} className="w-20 h-24 rounded-xl overflow-hidden bg-[#f4f4f4] shrink-0">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover"/>
                  </Link>
                  <div className="flex-1">
                    <div className="font-serif-bm text-base leading-tight">{item.name}</div>
                    <div className="text-sm mt-1 font-medium">{format(item.price)}</div>
                    <div className="mt-2 flex items-center gap-3">
                      <div className="flex items-center border border-[var(--bm-border)] rounded-full">
                        <button onClick={()=>updateQty(item.product_id, item.quantity - 1)} className="w-7 h-7 flex items-center justify-center" data-testid={`qty-dec-${item.product_id}`}>−</button>
                        <span className="text-sm min-w-5 text-center" data-testid={`qty-${item.product_id}`}>{item.quantity}</span>
                        <button onClick={()=>updateQty(item.product_id, item.quantity + 1)} className="w-7 h-7 flex items-center justify-center" data-testid={`qty-inc-${item.product_id}`}>+</button>
                      </div>
                      <button onClick={()=>removeFromCart(item.product_id)} className="text-xs text-[var(--bm-muted)] underline" data-testid={`remove-${item.product_id}`}>{t("cart.remove")}</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {cart.length > 0 && (
              <div className="border-t border-[var(--bm-border)] p-6">
                <div className="flex justify-between text-sm mb-2"><span>{t("cart.subtotal")}</span><span data-testid="cart-subtotal">{format(cartSubtotal)}</span></div>
                <div className="flex justify-between text-xs text-[var(--bm-muted)] mb-4"><span>{t("cart.shipping")}</span><span>{cartSubtotal >= 150 ? "FREE" : format(9.90)}</span></div>
                <button onClick={()=>{ setCartOpen(false); navigate("/checkout"); }} className="btn-primary w-full justify-center" data-testid="cart-checkout-btn">
                  <ShieldCheck size={16} weight="thin"/> {t("cart.checkout")}
                </button>
                <button onClick={()=>setCartOpen(false)} className="w-full mt-3 text-xs uppercase tracking-widest text-[var(--bm-muted)]" data-testid="cart-continue-btn">{t("cart.continue")}</button>
              </div>
            )}
          </aside>
        </div>
      )}
    </>
  );
}
